import React from 'react';
import { IonAvatar, IonText, IonIcon } from '@ionic/react';
import { starOutline, star, calendar, addOutline } from 'ionicons/icons';
import { getDefaultAvatar } from '../utils/defaultAvatar';
import './SessionHeader.css';

interface SessionHeaderProps {
  name: string;
  avatar?: string;
  isFavorite: boolean;
  onToggleFavorite: () => void;
  onAddToCalendar: () => void;
  onAskQuestion: () => void;
}

const SessionHeader: React.FC<SessionHeaderProps> = ({
  name,
  avatar = getDefaultAvatar(),
  isFavorite,
  onToggleFavorite,
  onAddToCalendar,
  onAskQuestion
}) => {
  return (
    <div className="session-header">
      <div className="session-header-content">
        <div className="session-info">
          <IonText>
            <h1 className="session-name">{name}</h1>
          </IonText>
        </div>
        {/*<IonAvatar className="session-avatar">
          <img src={avatar} alt={name} />
        </IonAvatar>*/}
      </div>

      <div className="session-actions">
        <button className="action-button" onClick={onToggleFavorite}>
          <IonIcon icon={isFavorite ? star : starOutline} />
          <span>Favorito</span>
        </button>

        <button className="action-button" onClick={onAddToCalendar}>
          <IonIcon icon={calendar} />
          <span>Calendario</span>
        </button>

        <button className="action-button primary" onClick={onAskQuestion}>
          <IonIcon icon={addOutline} />
          <span>Preguntar</span>
        </button>
      </div>
    </div>
  );
};

export default SessionHeader;
